import { Grid, Box, makeStyles, Typography } from "@material-ui/core";

import { Icon } from "../base";
import { ShaDowBox } from "../boxes";
import { COLORS } from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(3)}px ${theme.spacing(
      3.5
    )}px`,
  },
  iconBox: {
    position: "relative",
    marginRight: 20,
  },
  ext: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    color: COLORS.white,
  },
  text: {
    color: COLORS.darks[0][50],
    fontSize: 12,
  },
}));

export const Attachement = ({ icon, ext, name, date, size }) => {
  const classes = useStyles();

  return (
    <ShaDowBox>
      <Box className={classes.box}>
        <Grid container>
          <Grid item>
            <Box className={classes.iconBox}>
              <Icon src={icon} />
              <Typography className={classes.ext}>{ext}</Typography>
            </Box>
          </Grid>
          <Grid item>
            <Typography>{name}</Typography>
            <Typography
              className={classes.text}
              style={{ marginTop: 5, marginBottom: 2 }}
            >
              {date}
            </Typography>
            <Typography className={classes.text}>{size}</Typography>
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  );
};
